import { useTranslation } from "react-i18next";
import Breadcrumb from "../../../../core/common/Breadcrumb/breadcrumb";
import ProfileCard from "../../common/profileCard";
import StudentSidebar from "../../common/studentSidebar";
import ForumDetailTable from "./ForumDetailTable";

const StudentForumDetails = () => {
  const { t } = useTranslation();
  return (
    <>
      <div className="content">
        <div className="container">
          <ProfileCard />
          <div className="row">
            <StudentSidebar />
            <div className="col-lg-9">
              <Breadcrumb title={t("student.forums.details")} />
              <div className="page-title d-flex align-items-center justify-content-between">
                <h5>{t("student.forums.details")}</h5>
              </div>
              <ForumDetailTable />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default StudentForumDetails;
